import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

const SIZE_CLASS = {
  default: "max-w-lg",
  compact: "max-w-md",
  large: "max-w-2xl",
};

/**
 * Drop-in Dialog wrapper. Call sites still mount/unmount the component;
 * we keep `open` true while mounted.
 */
export function Modal({ title, onClose, children, size = "default", className }) {
  return (
    <Dialog
      open
      onOpenChange={(next) => {
        if (!next) onClose?.();
      }}
    >
      <DialogContent
        className={cn(
          "max-h-[90vh] overflow-y-auto",
          SIZE_CLASS[size] || SIZE_CLASS.default,
          className,
        )}
      >
        {title ? (
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
          </DialogHeader>
        ) : null}
        {children}
      </DialogContent>
    </Dialog>
  );
}
